import * as React  from "react";

export const getCsrfToken = () => {
  const meta = document.querySelector('meta[name=csrf-token');
  if (meta instanceof HTMLMetaElement) {
    return meta.content;
  }
  return '';
}
